module.exports = __webpack_public_path__ + "static/media/Graylinx_Login.8ec82465.png";